import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { InputComponent } from '../input/input.component';

@Component({
    selector: 'app-progress-dates',
    standalone: false,
    templateUrl: './progress-dates.component.html',
    styleUrl: './progress-dates.component.scss',
})
export class ProgressDatesComponent extends InputComponent implements OnInit {
    now = new Date();
    first: Date | undefined;
    last: Date | undefined;
    history: Date[] = [];
    future: Date[] = [];
    current: Date | undefined;
    today: Date | undefined;
    dates: Date[] = [];
    progress = 0;

    ngOnInit(): void {
        this.subscriptions.add(
            this.field.fc.valueChanges.subscribe(({ current, dates = [] }: { current: Date; dates: Date[] }) => {
                this.dates = dates;

                if (this.dates.length === 0) return;

                this.first = undefined;
                this.last = undefined;
                this.current = undefined;
                this.history = [];
                this.future = [];

                this.current = current;

                const firstDate = dates[0];
                const lastDate = dates.at(-1);

                const currentDateOnly = new Date(
                    current.getFullYear(),
                    current.getMonth(),
                    current.getDate()
                ).getTime();
                const firstDateOnly = new Date(
                    firstDate.getFullYear(),
                    firstDate.getMonth(),
                    firstDate.getDate()
                ).getTime();
                const lastDateOnly = new Date(
                    lastDate.getFullYear(),
                    lastDate.getMonth(),
                    lastDate.getDate()
                ).getTime();

                if (currentDateOnly !== firstDateOnly) this.first = firstDate;
                if (currentDateOnly !== lastDateOnly) this.last = lastDate;

                if (currentDateOnly === firstDateOnly) this.progress = 1;
                if (currentDateOnly === lastDateOnly) this.progress = 99;

                for (const date of dates.slice(1, -1)) {
                    const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
                    const currentOnly = new Date(
                        current.getFullYear(),
                        current.getMonth(),
                        current.getDate()
                    ).getTime();

                    if (dateOnly === currentOnly) {
                        const currentIndex = dates.indexOf(date);
                        const denom = Math.max(dates.length - 1, 1); // avoid division by 0

                        this.progress = Math.round((currentIndex / denom) * 100);

                        continue;
                    }

                    if (dateOnly < currentOnly) {
                        this.history.push(date);

                        continue;
                    }

                    this.future.push(date);
                }

                if (currentDateOnly < firstDateOnly) {
                    this.history.push(firstDate);
                    this.first = null;
                }

                if (currentDateOnly > lastDateOnly) {
                    this.future.push(lastDate);
                    this.last = null;
                }
            })
        );
    }

    list(dates: Date[]) {
        const entries = dates
            .slice(0, 10)
            .map(date => formatDate(date, 'EEE d MMM yyyy', 'nl'))
            .join('\n');

        if (dates.length <= 10) {
            return entries;
        }

        return `${entries}\n... (${dates.length - 10} meer)`;
    }
}
